import { ValueOf } from '../common/utils';
import { PRODUCT_SORT_TYPE } from '../../constants/service/app/productConstants';

export const PRODUCT_STATUS_V2 = {
  CONFIRM_READY: 'confirmReady',
  CONFIRM_REJECT: 'confirmReject',
  NOW_ON_SALE: 'nowOnSale',
  SOLD_OUT: 'soldOut',
  SALES_CLOSE: 'salesClose',
  SALES_PROHIBIT: 'salesProhibit',
  SALES_READY: 'salesReady',
  SALES_STOP: 'salesStop',
  DELETE: 'delete',
} as const;

export type PRODUCT_STATUS_V2 = ValueOf<typeof PRODUCT_STATUS_V2>;

export const PRODUCT_DISCOUNT_TYPE_V2 = {
  AMOUNT: 'amount',
  PERCENT: 'percent',
} as const;

export type PRODUCT_DISCOUNT_TYPE_V2 = ValueOf<typeof PRODUCT_DISCOUNT_TYPE_V2>;

export type MainCategoryItem = {
  id: number;
  name: string;
};

export type ProductSortType = ValueOf<typeof PRODUCT_SORT_TYPE>;
